import React from 'react'

import { formatDateRelative } from '@SonarCX/utilities'
import useStyles from './styles'

type DateComponentProps = {
  value: string | null
}

const DateComponent: React.FC<DateComponentProps> = ({ value }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {formatDateRelative(value ?? new Date(), true)}
    </div>
  )
}

export default React.memo(DateComponent)
